export default __webpack_public_path__ + "static/media/Battlegrace Boots.1ad54ef1.jpg";